import { Project } from 'routes/BudgetModule/shared/useGetProjects';

/**
 * Filter assigned projects based on assignedProjectsId
 */
export const filterAssignedProjects = (
    projects: Project[],
    assignedProjectsId: number[],
): Project[] =>
    projects.filter((project) => assignedProjectsId.includes(project.id!));

/**
 * Filter unassigned projects given the total projects list and the assigned projects list.
 */
export const filterUnassignedProjects = (
    projects: Project[],
    assignedProjects: Project[],
): Project[] =>
    projects.filter((project) => !assignedProjects.includes(project));
